export default "__VITE_ASSET__ODZQwz5I__"